module.exports = __webpack_public_path__ + "static/media/Skjonte.96cad6c4.mp3";